import React from 'react';
import Helmet from 'react-helmet';

export default ({ title, children }) => (
  <Helmet title={title}>
    <meta property="og:title" content={title} />
    <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <link rel="apple-touch-icon" href="/apple-icon-270x270.png" />
    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="/apple-icon-180x180.png"
    />
    {children}
  </Helmet>
);



// WEBPACK FOOTER //
// ./src/components/Helmet.js